import React, { useEffect, useState } from 'react';
import {
  collection,
  getDocs,
  query,
  orderBy,
  deleteDoc,
  doc
} from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { Link } from 'react-router-dom';
import '../../styles/admin.css';

export default function AdminPost() {
  const [articles, setArticles] = useState([]);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const q = query(collection(db, 'articles'), orderBy('date', 'desc')); // Sesuai Firestore kamu
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setArticles(data);
    } catch (err) {
      console.error("Gagal mengambil data:", err.message);
    }
  };

  const filtered = articles
    .filter(a => filter === 'all' || a.status === filter)
    .filter(a =>
      a.title?.toLowerCase().includes(search.toLowerCase()) ||
      a.excerpt?.toLowerCase().includes(search.toLowerCase())
    );

  const isAll = pageSize === 'all';
  const totalItems = filtered.length;
  const totalPages = isAll ? 1 : Math.max(1, Math.ceil(totalItems / pageSize));

  useEffect(() => {
    setCurrentPage(1);
  }, [filter, search, pageSize]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const startIndex = isAll ? 0 : (currentPage - 1) * pageSize;
  const endIndex = isAll ? totalItems : startIndex + pageSize;
  const displayed = isAll ? filtered : filtered.slice(startIndex, endIndex);

  const toggleSelect = id =>
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );

  const deleteSelected = async () => {
    if (!window.confirm(`Hapus ${selectedIds.length} artikel?`)) return;
    await Promise.all(
      selectedIds.map(id => deleteDoc(doc(db, 'articles', id)))
    );
    setSelectedIds([]);
    fetchArticles();
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h2>Daftar Artikel</h2>
          <p className="text-muted-small">Kelola artikel yang tampil di halaman publik.</p>
        </div>
        <Link to="/admin/post/new" className="btn btn-primary">
          + Buat Artikel
        </Link>
      </div>

      <div className="admin-toolbar">
        <select
          className="form-select w-auto"
          value={filter}
          onChange={e => setFilter(e.target.value)}
        >
          <option value="all">Semua ({articles.length})</option>
          <option value="published">
            Terbit ({articles.filter(a => a.status === 'published').length})
          </option>
          <option value="draft">
            Draf ({articles.filter(a => a.status === 'draft').length})
          </option>
        </select>

        <input
          type="text"
          className="form-control w-auto"
          placeholder="Cari Judul/Excerpt"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        <div className="admin-toolbar-group">
          <label className="text-muted-small">Tampil</label>
          <select
            className="form-select w-auto"
            value={pageSize}
            onChange={e => setPageSize(e.target.value === 'all' ? 'all' : Number(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value="all">Semua</option>
          </select>
        </div>

        {selectedIds.length > 0 && (
          <button className="btn btn-danger" onClick={deleteSelected}>
            Hapus Terpilih ({selectedIds.length})
          </button>
        )}
      </div>

      <div className="admin-pagination-info">
        Menampilkan {totalItems === 0 ? 0 : startIndex + 1}–{Math.min(endIndex, totalItems)} dari {totalItems} artikel
      </div>

      <div className="table-responsive admin-table-wrapper">
        <table className="table admin-table align-middle">
          <thead className="table-light">
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={() => {
                    const displayedIds = displayed.map(a => a.id);
                    if (displayedIds.every(id => selectedIds.includes(id))) {
                      setSelectedIds(prev => prev.filter(id => !displayedIds.includes(id)));
                    } else {
                      setSelectedIds(prev => Array.from(new Set([...prev, ...displayedIds])));
                    }
                  }}
                />
              </th>
              <th>Judul</th>
              <th>Status</th>
              <th>Pengunjung</th>
              <th>Tanggal</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {displayed.map(a => (
              <tr key={a.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(a.id)}
                    onChange={() => toggleSelect(a.id)}
                  />
                </td>
                <td>{a.title || '(tanpa judul)'}</td>
                <td>
                  <span
                    className={`badge bg-${
                      a.status === 'published' ? 'success' : 'secondary'
                    }`}
                  >
                    {a.status === 'published' ? 'Terbit' : 'Draf'}
                  </span>
                </td>
                <td>{a.views || 0}</td>
                <td>
                  {a.date?.seconds
                    ? new Date(a.date.seconds * 1000).toLocaleDateString()
                    : '-'}
                </td>
                <td>
                  <div className="btn-group btn-group-sm">
                    <Link
                      to={`/admin/post/edit/${a.id}`}
                      className="btn btn-outline-primary"
                    >
                      Edit
                    </Link>
                    <button
                      className="btn btn-outline-danger"
                      onClick={async () => {
                        if (window.confirm('Yakin hapus?')) {
                          await deleteDoc(doc(db, 'articles', a.id));
                          fetchArticles();
                        }
                      }}
                    >
                      Hapus
                    </button>
                    <Link
                      to={`/post/${a.slug || a.id}`}
                      className="btn btn-outline-secondary"
                      target="_blank"
                    >
                      Lihat
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
            {displayed.length === 0 && (
              <tr>
                <td colSpan="7" className="text-center">
                  Tidak ada artikel ditemukan
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {!isAll && totalPages > 1 && (
        <div className="pagination-footer admin-pagination-footer">
          <button
            className="btn btn-outline-success btn-sm"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
          >
            ← Sebelumnya
          </button>
          <select
            className="form-select form-select-sm page-select"
            value={currentPage}
            onChange={e => setCurrentPage(Number(e.target.value))}
          >
            {Array.from({ length: totalPages }).map((_, idx) => (
              <option key={idx + 1} value={idx + 1}>
                Halaman {idx + 1} / {totalPages}
              </option>
            ))}
          </select>
          <button
            className="btn btn-outline-success btn-sm"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
          >
            Berikutnya →
          </button>
        </div>
      )}
    </div>
  );
}
